import React, { useEffect } from 'react';
import {
  Divider,
  Icon,
  Typography,
  Popover,
  List,
  notification,
  Button,
  Modal,
  Result,
  Upload,
} from 'antd';
import { concat, isEmpty, isNil } from 'ramda';
import SockJS from 'sockjs-client';
import Context from '../Container/Context';
import { SignInModal } from '../../biz';
import { asserts, network, generators, auth, maths } from '../../../utils';
import { newGenerateTree, formatToFixed } from '../../../utils/biz';
import { PopUp } from '../../common';
import { message } from '../../biz';
import { useModel, useDidMount } from '../../use';
import api from '../../../config/api';
import getArticle from '../../../service/notice';
import LinkTo from './LinkTo';
import useContext from '../Container/useLayoutContext';
import moment from 'moment';
import './TopHeader.less';

const { Text } = Typography;
const { Item } = List;
const { generatorArray, generatorObject } = generators;
const { showAuthModal } = auth;
const { formatToFixed2 } = formatToFixed;

const sigininIcon = `${process.env.TARGET}static/imgs/signin/signin.png`;

// QQ 客服
const renderTitle = (array) => {
  const handleGoNewPage = (e, item) => {
    e.preventDefault();
    e.stopPropagation();
    if (item.qwAgentLink) {
      window.open(item.qwAgentLink, '_blank', 'noopener,noreferrer');
    }
  };
  return (
    <List>
      {array.map((item, index) => (
        <Item key={item && item.qid}>
          <a
            className="header-consult pointer"
            // href={`http://wpa.qq.com/msgrd?v=3&uin=${item && item.qqNo}&site=qq&menu=yes`}
            href="/"
            target="_blank"
            rel="nofollow noopener noreferrer"
            onClick={(e) => handleGoNewPage(e, item)}
          >
            <img src={`${process.env.TARGET}static/imgs/qiwei.svg`} alt="qiwei-logo" />
            <span>{item && item.qqName}</span>
            {/* eslint-disable-next-line */}
            <label className="text-link">new !</label>
          </a>
        </Item>
      ))}
    </List>
  );
};

const QQService = () => {
  const { state, dispatch } = useModel({
    state: {
      conList: [],
      complainList: [],
      applicationList: [],
    },
    reducers: {
      updateState: (state, payload) => ({ ...state, ...payload }),
    },
    effects: {
      getConsult: async ({ dispatch }) => {
        const response = await network({
          url: api.home.consult,
          method: 'get',
        });
        if (response.success) {
          if (!response.data.success) {
            message.error(response.data.message);
            return;
          }
          const zxQqList = generatorArray(response.data.data.zxQqList) || [];
          const jszxQqList = generatorArray(response.data.data.jszxQqList) || [];
          const tsQqList = generatorArray(response.data.data.tsQqList) || [];
          const zxfbQqList = generatorArray(response.data.data.zxfbQqList) || [];
          const qqList = concat(zxQqList, jszxQqList);
          dispatch('updateState')({
            conList: qqList,
            complainList: tsQqList,
            applicationList: zxfbQqList,
          });
        }
      },
    },
  });
  const { conList, complainList, applicationList } = state;

  useDidMount(() => dispatch('getConsult')());

  return (
    <>
      {/* <Text className="hover-red text-secondary">在线咨询</Text> */}
      <Popover content={renderTitle(conList)}>
        <span className="hover-red pointer consult-logo">
          <img src={`${process.env.TARGET}static/imgs/qiwei.svg`} alt="qiwei-logo" />
        </span>
      </Popover>
      {/* <Popover content={renderTitle(complainList)}>
        <span className="hover-red pointer consult-logo">
          <img src={`${process.env.TARGET}static/imgs/img/complain.png`} alt="qq-logo" />
        </span>
      </Popover> */}
      <Popover content={renderTitle(applicationList)}>
        <span className="hover-red pointer consult-logo">
          <img src={`${process.env.TARGET}static/imgs/img/biao.png`} alt="qiwei-logo" />
        </span>
      </Popover>
    </>
  );
};

// 顶部导航
const TopDynamicNavs = React.memo(() => {
  const { topMenuList, principal, history } = React.useContext(Context);
  const isLoginIn = asserts.isExist(principal);

  const [helpUrl, setHelpUrl] = React.useState(undefined);

  useDidMount(() => {
    const fetchHelpUrl = async () => {
      const res = await getArticle();
      if (res.success) {
        const { rows = [] } = generatorObject(res.data);
        const treeData = newGenerateTree(rows);
        let url;
        if (treeData.length === 0) {
          url = '/notification/message/all?acId=-10';
        } else {
          treeData.forEach((item) => {
            url = `/notification/${item.acCode}?acId=${item.acId}`;
          });
          treeData.forEach((item) => {
            if (item.acCode === 'HELPCENTER') {
              if (item.children) {
                const [helpItem = {}] = item.children;
                url = `/notification/${helpItem.pacCode}/${helpItem.acCode}?acId=${helpItem.acId}`;
              } else {
                url = `/notification/${item.acCode}?acId=${item.acId}`;
              }
            }
          });
        }
        setHelpUrl(url);
      }
    };
    fetchHelpUrl();
  });

  const handleClick = (url) => {
    if (!isLoginIn) {
      showAuthModal();
      return;
    }
    if (url.includes('/notification')) {
      helpUrl && history.push(helpUrl);
    } else {
      history.push(url);
    }
  };
  if (isEmpty(topMenuList)) return null;
  return topMenuList.map(({ moduCode, moduName, menuUrl, linkType }) => {
    if (`${linkType}` === '2')
      return (
        <React.Fragment key={menuUrl}>
          <a href={menuUrl} target="_blank" rel="nofollow noopener noreferrer">
            <Text className="hover-red">{moduName}</Text>
          </a>
          <Divider type="vertical" className="divider-xxs" />
        </React.Fragment>
      );
    if (moduCode === 'custItemApplications') {
      return (
        <React.Fragment key={menuUrl}>
          <Popover
            content={
              <img
                src={`${process.env.TARGET}static/imgs/qrCode.png`}
                style={{ width: 100, margin: '-12px -16px' }}
                alt="qr-code"
              />
            }
          >
            <Text className="hover-red pointer" onClick={() => handleClick(menuUrl)}>
              {moduName}
            </Text>
          </Popover>
          <Divider type="vertical" className="divider-xxs" />
        </React.Fragment>
      );
    }
    return (
      <React.Fragment key={menuUrl}>
        <Text className="hover-red pointer" onClick={() => handleClick(menuUrl)}>
          {moduName}
        </Text>
        <Divider type="vertical" className="divider-xxs" />
      </React.Fragment>
    );
  });
});

// const logout = async (history, contextValue) => {
//   const response = await network.get(api.core.logout, { silence: true });
//   console.log(response, 'rressssssssssssss');
//   if (response.success || response.status === 401) {
//     contextValue.resetCtxState();
//     history.replace('/login');
//     // 状态清空后，需要保持菜单
//     contextValue.updateMenus();
//     localStorage.setItem('login', 'false');
//   }
// };

// 签到
const SignInfo = React.memo(({ onSignIn, signinFlag }) => {
  const handleSignIn = () => {
    onSignIn && onSignIn();
  };
  return (
    <>
      <div onClick={handleSignIn} style={{ display: 'inline-block' }}>
        <span className="hover-red pointer">
          <img
            style={{ width: 14, height: 14, marginRight: 4 }}
            alt="加载中..."
            src={sigininIcon}
          />
          <Text>{signinFlag ? '已签到' : '签到'}</Text>
        </span>
      </div>
      <Divider type="vertical" className="divider-xxs" />
    </>
  );
});

// 角标通知
const CornerNotice = React.memo(({ unreadCount }) => {
  return (
    <>
      <LinkTo to="/notification/message/unread?acId=-11">
        <span className="hover-red pointer">
          <Icon type="bell" className={!!unreadCount && 'message'} />
          <Text>通知</Text>
          <span className="text-red">{!!unreadCount && `(${unreadCount})`}</span>
        </span>
      </LinkTo>
      <Divider type="vertical" className="divider-xxs" />
    </>
  );
});

const NotGetContent = React.memo(({ onChangeVisible, list, receive, onReceive, history }) => {
  const [couponList, setCouponList] = React.useState([]);
  const total = couponList.reduce((prev, cur) => prev + +cur.unUsedAmt, 0);
  const [btnFlag, setBtnFlag] = React.useState(true);

  React.useEffect(() => {
    setCouponList(list);
  }, [list]);

  const handleClose = () => {
    onChangeVisible && onChangeVisible(false, 'notGet');
  };

  //领取单个优惠券
  const handleReceiveItem = async (item, key) => {
    setBtnFlag(false);
    const response = await network({
      url: api.home.coupon,
      method: 'put',
      data: { gpnIds: [item.gpnId] },
    });
    if (response.success) {
      const result = generatorObject(response.data);
      if (result.success) {
        const newCouponList = couponList.map((item, index) => {
          if (key === index) {
            return { ...item, btnFlag: true };
          } else {
            return { ...item };
          }
        });
        setCouponList(newCouponList);
        const couponFlagList = couponList.filter((item) => item.btnFlag);
        if (couponFlagList.length === couponList.length - 1) {
          onReceive();
        }
        setBtnFlag(true);
      } else {
        message.error(result.message);
      }
    }
  };

  //一键领取优惠券
  const handleReceive = async () => {
    setBtnFlag(false);
    const gpnIdList = couponList.filter((item) => !item.btnFlag);
    const newGpnIdList = gpnIdList.map((item) => item.gpnId);
    const response = await network({
      url: api.home.coupon,
      method: 'put',
      data: { gpnIds: newGpnIdList },
    });
    if (response.success) {
      const result = generatorObject(response.data);
      if (result.success) {
        onReceive();
      } else {
        message.error(result.message);
      }
    }
  };

  const gotoCart = () => {
    onChangeVisible && onChangeVisible(false, 'notGet');
    history.push('/cart');
  };

  return (
    <div>
      {receive ? (
        <div className="receive-container align-center">
          <p className="icon-header">
            <img
              alt=""
              src={`${process.env.TARGET}static/imgs/coupon/success.svg`}
              style={{ width: 80, height: 80 }}
            />
          </p>
          <div className="desc">
            <div>恭喜您！领取成功</div>
            <Text type="secondary">感谢您的参与，祝您购物愉快</Text>
          </div>
          <div className="operationBtn">
            <Button type="primary" onClick={gotoCart}>
              立即使用
            </Button>
            <Button onClick={handleClose}>关闭</Button>
          </div>
          <div className="align-left">
            <Text type="secondary">3秒后自动关闭</Text>
          </div>
        </div>
      ) : (
        <div className="coupon-container">
          <div className="header align-center">
            <img
              src={`${process.env.TARGET}static/imgs/coupon/header.png`}
              alt=""
              style={{ width: 295, height: 115 }}
            />
          </div>
          <div
            className="coupon"
            style={{
              background: `url('${process.env.TARGET}static/imgs/coupon/bg.png') no-repeat`,
            }}
          >
            {couponList.length === 0 ? (
              <div className="title align-center" style={{ marginTop: 100, marginBottom: 100 }}>
                <div>暂无可领取的优惠券</div>
                <div>请期待后续活动</div>
              </div>
            ) : (
              <div>
                <div className="title align-center">
                  <div>恭喜您</div>
                  <div>
                    共获得{total}元优惠券！
                    <a href="/cart" style={{ color: 'yellow' }}>
                      立即使用
                    </a>
                  </div>
                </div>
                <div className="main">
                  {couponList.map((item, index) => (
                    <div className="item" key={index}>
                      <div className="left-amout item-part">
                        <div>
                          <em>￥</em>
                          <span>{item.unUsedAmt}</span>
                        </div>
                        <Text type="secondary" ellipsis>
                          {item.useRule}
                        </Text>
                      </div>
                      <div className="middle-radius item-part" />
                      <div className="right-desc item-part">
                        <div title={item.cpnName}>{item.cpnName}</div>
                        <div>
                          <Text type="secondary">
                            {moment(item.validEnd).diff(moment(), 'day')}天内可用
                          </Text>
                        </div>
                        <div>
                          <Text
                            type="secondary"
                            style={{
                              display: 'block',
                              width: 'auto',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                            }}
                          >
                            适用范围:{item.udcDesc}
                          </Text>
                        </div>
                      </div>
                      <div className="item-part">
                        <Button
                          className={item.btnFlag ? 'received-btn' : 'receive-btn'}
                          disabled={item.btnFlag}
                          onClick={() => handleReceiveItem(item, index)}
                        >
                          {item.btnFlag ? '已领' : '领取'}
                        </Button>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="arrow align-center">
                  <img
                    alt=""
                    src={`${process.env.TARGET}static/imgs/coupon/arrow.svg`}
                    style={{ width: 16, height: 14 }}
                  />
                </div>
                <div
                  className="submit-btn align-center pointer"
                  onClick={handleReceive}
                  style={{ pointerEvents: btnFlag ? 'auto' : 'none' }}
                >
                  一键领取
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
});

const GettedContent = React.memo(({ onChangeVisible, list, type, history }) => {
  const total = list.reduce((prev, cur) => prev + +cur.unUsedAmt, 0);

  const handleClose = () => {
    onChangeVisible && onChangeVisible(false, type);
  };

  const handlegotoNextPage = () => {
    onChangeVisible && onChangeVisible(false, type);
    history.push('/profile/memberCoupon');
  };
  return (
    <div className="coupon-container">
      <div className="header align-center">
        <img
          src={`${process.env.TARGET}static/imgs/coupon/header.png`}
          alt=""
          style={{ width: 295, height: 115 }}
        />
      </div>
      <div
        className="coupon"
        style={{
          background:
            type === 'newGet'
              ? `url('${process.env.TARGET}static/imgs/coupon/newGetBg.png') no-repeat`
              : `url('${process.env.TARGET}static/imgs/coupon/expringBg.png') no-repeat`,
        }}
      >
        <div className="title align-center">
          <div>温馨提醒</div>
          <div>
            {type === 'newGet'
              ? `您有${total}元新领取的优惠券,可前往个人中心查看并领取使用!`
              : `您有${total}元优惠券即将过期,可前往个人中心查看并领取使用!`}
          </div>
        </div>
        <div className="main">
          {list.map((item, index) => (
            <div className="item" key={index}>
              <div className="left-amout item-part">
                <div>
                  <em>￥</em>
                  <span>{item.unUsedAmt}</span>
                </div>
                <Text type="secondary" ellipsis>
                  {item.useRule}
                </Text>
              </div>
              <div className="middle-radius item-part" />
              <div className="right-desc item-part">
                <div title={item.cpnName}>{item.cpnName}</div>
                <div>
                  <Text type="secondary">
                    {moment(item.validEnd).diff(moment(), 'day')}天内可用
                  </Text>
                </div>
                <div>
                  <Text
                    type="secondary"
                    style={{
                      display: 'block',
                      width: 'auto',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                    }}
                  >
                    适用范围：{item.udcDesc}
                  </Text>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="arrow align-center">
          <img
            alt=""
            src={`${process.env.TARGET}static/imgs/coupon/arrow.svg`}
            style={{ width: 16, height: 14 }}
          />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
          <div
            className={
              type === 'newGet'
                ? 'align-center pointer newGetBtn'
                : 'align-center pointer expringBtn'
            }
            style={{ width: '40%' }}
            onClick={handleClose}
          >
            知道了
          </div>
          <div
            className={
              type === 'newGet'
                ? 'align-center pointer newGetBtn'
                : 'align-center pointer expringBtn'
            }
            style={{ width: '40%' }}
            onClick={handlegotoNextPage}
          >
            前往个人中心
          </div>
        </div>
      </div>
    </div>
  );
});

const CouponModal = React.memo(({ visible, type, list, handleVisile, history }) => {
  const [receive, setReceive] = React.useState(false); //是否切换为已领取

  const handleCancel = () => {
    handleVisile && handleVisile(false, type);
    // localStorage.setItem('login', 'false');
  };

  const handleReceive = () => {
    setReceive(true);
    setTimeout(() => {
      handleCancel();
      setReceive(false);
    }, 3000);
  };

  return (
    <Modal
      visible={visible}
      footer={null}
      wrapClassName="coupon-modal"
      closeIcon={<Icon type="close" style={{ color: receive ? 'rgba(0,0,0,0.4)' : '#fff' }} />}
      onCancel={handleCancel}
    >
      {type === 'notGet' ? (
        <NotGetContent
          onChangeVisible={handleVisile}
          list={list}
          receive={receive}
          onReceive={handleReceive}
          history={history}
        />
      ) : (
        <GettedContent onChangeVisible={handleVisile} list={list} type={type} history={history} />
      )}
    </Modal>
  );
});

export default React.memo(() => {
  const {
    principal,
    memberInfo,
    logout,
    history,
    isSignIn,
    memberIsWhite,
    updateSignStatus,
  } = React.useContext(Context);
  const isLoginIn = asserts.isExist(principal);
  const contextValue = useContext();
  const [unreadCount, setUnreadCount] = React.useState(0);
  const [notGetVisible, setNotGetVisible] = React.useState(false); // 未领取
  const [newGetVisible, setNewGetVisible] = React.useState(false); // 新领取
  const [expiringVisible, setExpiringVisible] = React.useState(false); // 即将过期
  const [notGetList, setNotGetList] = React.useState([]); // 未领取
  const [newGetList, setNewGetList] = React.useState([]); // 新领取
  const [expiringList, setExpiringList] = React.useState([]); // 即将过期
  const [visible, setVisible] = React.useState(false);
  const [currentList, setCurrentList] = React.useState([]);
  const [type, setType] = React.useState('');
  const [signInVisible, setSignInVisible] = React.useState(false);
  const [signinFlag, setSigninFlag] = React.useState(isSignIn); // 是否已经签到
  const [showPoint, setShowPoint] = React.useState(false);
  const [memberPicUrl, setMemberPicUrl] = React.useState(null);

  useEffect(() => {
    if (isLoginIn) {
      let cid = localStorage.getItem('cid');
      const socket = new SockJS(`${process.env.SERVE}/webSocket.do?cid=${cid}`);
      console.log(socket, 'socketsocketsocketsocketsocket');
      socket.onmessage = function(event) {
        const eventObj = JSON.parse(event.data);
        console.warn(eventObj, 'ceshiceshiceshiceshi'); // eslint-disable-line
        const {
          msgType = '',
          msgNo = '',
          loginName = '',
          msgId = '',
          showArea = '',
          cmmId = '',
        } = eventObj;
        if (msgType === '_MSGCOUNT' || !msgType) {
          setUnreadCount(msgNo);
          // 如果是即时消息，弹窗提示
          if (eventObj.last) {
            notification.info({
              description: eventObj.message,
              btn: (
                <Button type="primary" onClick={() => history.push('/notification/message/all')}>
                  查看
                </Button>
              ),
            });
          }
        }
        if (msgType === '_ACCOUNT') {
          // 如果是即时消息，弹窗提示
          if (eventObj.last) {
            console.warn(eventObj, eventObj.message, 'headerheaderheaderheader'); // eslint-disable-line
            if (eventObj.message === 'true') {
              Modal.warning({
                title: `${loginName}账号被禁用，请联系管理员`,
                content: '',
                centered: true,
                onOk: () => {
                  contextValue.resetCtxState();
                  history.replace('/login');
                  // 状态清空后，需要保持菜单
                  contextValue.updateMenus();
                  localStorage.setItem('login', 'false');
                },
              });
            } else {
              // message.warn(`${loginName}账号被修改，需重新登录`);
              contextValue.resetCtxState();
              history.replace('/login');
              // 状态清空后，需要保持菜单
              contextValue.updateMenus();
              localStorage.setItem('login', 'false');
            }
          }
        }
        // 优惠券
        if (msgType === '_COUPON') {
          console.warn(eventObj, eventObj.message, '优惠券');
          let { notGetCoupons = [], newGetCoupons = [], expiringCoupons = [] } = JSON.parse(
            eventObj.message,
          );
          console.warn(notGetCoupons, newGetCoupons, expiringCoupons, '优惠券111');
          // 未领取
          if (Array.isArray(notGetCoupons) && notGetCoupons.length > 0) {
            setNotGetList(notGetCoupons);
            setNotGetVisible(true);
          }
          // 新领取
          if (Array.isArray(newGetCoupons) && newGetCoupons.length > 0) {
            setNewGetList(newGetCoupons);
            setNewGetVisible(true);
          }
          // 即将过期
          if (Array.isArray(expiringCoupons) && expiringCoupons.length > 0) {
            setExpiringList(expiringCoupons);
            setExpiringVisible(true);
          }
        }
        if (
          showArea === 'FRONT' &&
          (msgType === '_FEEDBACK' || msgType === '_TEST' || msgType === '_RETURN')
        ) {
          if (eventObj.last) {
            let msg = JSON.parse(eventObj.message);
            // 售后服务
            notification.open({
              style: {
                backgroundColor: '#fff',
                padding: '6px 0px',
              },
              className: `notification-modal`,
              message: null,
              key: msg[0].docNo,
              description: (
                <Result
                  status="success"
                  title={msg[0].title}
                  extra={[
                    <div className="content pointer">
                      <Text>{msg[0].content}</Text>
                      <Button
                        type="primary"
                        onClick={(e) => handleWaitSuppQuote(e, msg, msgType, msgId, cmmId)}
                      >
                        点击查看
                      </Button>
                    </div>,
                  ]}
                />
              ),
              duration: 0,
              onClick: (e) => handleWaitSuppQuote(e, msg, msgType, msgId, cmmId),
            });
          }
        }
        if (showArea === 'FRONT' && msgType === '_CUSTOM') {
          if (eventObj.last) {
            let msg = JSON.parse(eventObj.message);
            // 售后服务
            notification.open({
              style: {
                backgroundColor: '#fff',
                padding: '6px 0px',
              },
              className: `notification-modal`,
              message: null,
              key: eventObj.msgId,
              description: (
                <Result
                  status="success"
                  title={msg[0].title}
                  extra={[
                    <div className="content pointer">
                      <div dangerouslySetInnerHTML={{ __html: msg[0].content }} />
                      <Button
                        type="primary"
                        onClick={(e) => handleWaitSuppQuote(e, msg, msgType, msgId, cmmId)}
                      >
                        点击查看
                      </Button>
                    </div>,
                  ]}
                />
              ),
              duration: 0,
              onClick: (e) => handleWaitSuppQuote(e, msg, msgType, msgId, cmmId),
            });
          }
        }
        // 会员权益审核状态
        if (msgType === '_EQUITY_APPLY') {
          // 如果是即时消息，弹窗提示
          if (eventObj.last) {
            let msg = JSON.parse(eventObj.message);
            // 售后服务
            notification.open({
              style: {
                backgroundColor: '#fff',
                padding: '6px 0px',
              },
              className: `notification-modal`,
              message: null,
              key: eventObj.msgId,
              description: (
                <Result
                  status="success"
                  title={msg[0].title}
                  extra={[
                    <div className="content pointer">
                      <div dangerouslySetInnerHTML={{ __html: msg[0].content }} />
                    </div>,
                  ]}
                />
              ),
              duration: 0,
              onClick: (e) => handleCheckEquity(msg),
            });
          }
        }
        // 需求列表
        if (msgType === '_DEMAND') {
          // 如果是即时消息，弹窗提示
          if (eventObj.last) {
            let msg = JSON.parse(eventObj.message);
            // 需求列表
            notification.open({
              style: {
                backgroundColor: '#fff',
                padding: '6px 0px',
              },
              className: `notification-modal`,
              message: null,
              key: eventObj.msgId,
              description: (
                <Result
                  status="success"
                  title={msg[0].title}
                  extra={[
                    <div className="content pointer">
                      <div dangerouslySetInnerHTML={{ __html: msg[0].content }} />
                    </div>,
                  ]}
                />
              ),
              duration: 0,
              onClick: (e) => handleCheckDemand(msg),
            });
          }
        }
      };
    }
  }, [isLoginIn]);

  useEffect(() => {
    setSigninFlag(isSignIn);
  }, [isSignIn]);

  useEffect(() => {
    setMemberPicUrl(memberInfo.aclUser ? memberInfo.aclUser.picAddr : null);
  }, [memberInfo]);

  useEffect(() => {
    setShowPoint(memberIsWhite);
  }, [memberIsWhite]);

  // useDidMount(() => {
  //   fetchPointShow();
  // });
  // const fetchPointShow = async () => {
  //   const res = await network({
  //     url: api.finance.introduction,
  //     method: 'get',
  //     params: { confCode: 'pointShowStatus' },
  //   });
  //   if (res.success) {
  //     const [config = {}] = generatorArray(generatorObject(res.data).rows);
  //     if (!isEmpty(config)) {
  //       setShowPoint(config.confValue === 'Y');
  //     }
  //   }
  // };

  const handleWaitSuppQuote = async (e, msg, msgType, msgId, cmmId) => {
    let event = e || window.event;
    event.stopPropagation();
    let url = null;
    await network({
      url: api.notification.messageDetail,
      method: 'get',
      params: { cmmId: msgId },
    });
    if (msgType === '_FEEDBACK') {
      // 跳转售后页面
      url = `afterSales/feedbackRecord?fbNo=${msg[0].docNo}`;
    } else if (msgType === '_TEST') {
      // 跳转检测服务消息页面
      url = `afterSales/detectionRecord?fbNo=${msg[0].docNo}`;
    } else if (msgType === '_RETURN') {
      // 跳转退货页面
      url = `orderCenter/returnsRecord?searchValue=${msg[0].docNo}`;
    } else if (msgType === '_CUSTOM') {
      url = `notification/message/unread/detail?acId=-11&cmmId=${cmmId}`;
    }
    // history.replace(url);
    window.open(`${process.env.TARGET}${url}`, '_blank');
    notification.close(msg[0].docNo); // 关闭推送消息
  };

  const handleCheckEquity = (msg) => {
    window.open(`${process.env.TARGET}profile/memberInfo`, '_blank');
    notification.close(msg[0].docNo); // 关闭推送消息
  };

  const handleCheckDemand = (msg) => {
    window.open(`${process.env.TARGET}customDemand/myDemandList`, '_blank');
    notification.close(msg[0].docNo); // 关闭推送消息
  };

  useEffect(() => {
    if (notGetVisible && newGetVisible && expiringVisible) {
      // 如果三个都存在，即三个慢慢打开先打开第一个未领取的
      setVisible(notGetVisible);
      setCurrentList(notGetList);
      setType('notGet');
    } else {
      // 有不存在true的
      // 存在未领取的
      if (notGetVisible) {
        setVisible(notGetVisible);
        setCurrentList(notGetList);
        setType('notGet');
      } else {
        // 未领取的不存在 新领取的存在
        if (newGetVisible) {
          setVisible(newGetVisible);
          setCurrentList(newGetList);
          setType('newGet');
        } else {
          // 未领取的不存在 新领取的不存在 即将过期的存在
          setVisible(expiringVisible);
          setCurrentList(expiringList);
          setType('expiring');
        }
      }
    }
  }, [notGetVisible, newGetVisible, expiringVisible, notGetList, newGetList, expiringList]);

  const handleVisile = (flag, couponType) => {
    if (couponType === 'notGet') {
      setNotGetVisible(flag);
    }
    if (couponType === 'newGet') {
      setNewGetVisible(flag);
    }
    if (couponType === 'expiring') {
      setExpiringVisible(flag);
    }
  };

  // 点击签到打开签到弹窗
  const handleSignIn = () => {
    setSignInVisible(true);
  };

  // 签到成功
  const handleSignInSuccessFul = (flag) => {
    setSignInVisible(false);
    if (flag) {
      setSigninFlag(true);
      updateSignStatus();
    }
  };

  const beforeUpload = async (file) => {
    const isPicture =
      file.type === 'image/jpeg' ||
      file.type === 'image/png' ||
      file.type === 'image/jpg' ||
      file.type === 'image/gif' ||
      file.type === 'image/bmp';
    if (!isPicture) {
      message.warning('请上传图片');
      return;
    }
    const isLimit10M = file.size / 1024 / 1024 < 10;
    if (!isLimit10M) {
      message.warning('上传文件超过限制大小！');
      return;
    }
    const r = new FileReader();
    r.readAsDataURL(file);
    r.onload = (e) => {
      file.thumbUrl = e.target.result;
    };
    let formData = new FormData();
    formData.append('file', file);
    formData.append('userId', principal.userId);
    //图片上传在这里
    await network({
      url: api.profile.updateAvatar,
      method: 'post',
      data: formData,
    }).then((res) => {
      let picUrl = res.data.data;
      setMemberPicUrl(picUrl);
      return;
    });
    return false;
  };

  const renderMemberInfo = () => {
    const {
      picAddr = null,
      levelName = null,
      lvName = null,
      growthValue = 0,
      nextMemberSmallLevel = {},
      saleVolume = 0,
      disAmt = 0,
    } = memberInfo;
    let pointTotal =
      !isEmpty(nextMemberSmallLevel) && !isNil(nextMemberSmallLevel)
        ? nextMemberSmallLevel.saleVolumeBegin
          ? nextMemberSmallLevel.saleVolumeBegin
          : nextMemberSmallLevel.beginPoints
        : 0; // 斜杠后面的值
    let needPoint = Math.round(
      maths.mul(maths.mul(maths.sub(pointTotal || 0, saleVolume || 0), 10000), 6),
    );
    return (
      <div className="memberInfo-wrapper">
        <div className="left-img">
          <Upload
            name="avatar"
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            beforeUpload={beforeUpload}
          >
            {memberPicUrl ? (
              <img
                src={`${process.env.ASSETS}/${memberPicUrl}`}
                alt="avatar"
                style={{ width: 50, height: 50, borderRadius: 30 }}
              />
            ) : (
              <img
                src={`${process.env.TARGET}static/imgs/signin/elephant.png`}
                alt="avatar"
                style={{ width: 50, height: 50, borderRadius: 30 }}
              />
            )}
          </Upload>
        </div>

        <div className="member-info">
          <p>
            <span>您是</span>
            <span style={{ color: '#FD9101' }}>{levelName}</span>
            {lvName ? <span className="member-level">{lvName}</span> : null}
          </p>
          <p>
            <span>当前成长值:</span>
            <span className="text-red">{growthValue}</span>
          </p>
          <p>
            <span>距离升级还有:</span>
            <span className="text-red">{needPoint}</span>
            <span style={{ color: '#B4812E' }}>元</span>
          </p>
          <p>
            <span>累计已省:</span>
            <span className="text-red">{disAmt}元</span>
          </p>
        </div>
      </div>
    );
  };

  return (
    <>
      <main className="topBar">
        <div className="left-wrapper">
          <Icon type="phone" />
          <Text className="text-secondary">400-8843-125</Text>
          <Divider type="vertical" className="divider-xxs" />
          <Text className="text-secondary">工作日: </Text>
          <Text className="text-secondary">0573-82203125 转 678</Text>
          <Divider type="vertical" className="divider-xxs" />
          <TopDynamicNavs />
          <Popover
            content={
              <img
                src={`${process.env.TARGET}static/imgs/qr-code.png`}
                style={{ width: 100, margin: '-12px -16px' }}
                alt="qr-code"
              />
            }
          >
            <span className="hover-red pointer">
              <Icon type="qrcode" />
              <Text>东明微信</Text>
            </span>
          </Popover>
          <Divider type="vertical" className="divider-xxs" />
          <span
            className="pointer"
            onClick={() => window.open('https://www.moxueyuan.com/admin.php/login')}
          >
            <img src={`${process.env.TARGET}static/imgs/learnIcon.png`} style={{ height: 26 }} />
            <Text> 学习平台</Text>
          </span>
          <Divider type="vertical" className="divider-xxs" />
          <QQService />
        </div>
        <aside className="aside">
          {isLoginIn ? (
            <>
              {showPoint ? <SignInfo onSignIn={handleSignIn} signinFlag={signinFlag} /> : null}
              <CornerNotice unreadCount={unreadCount} />
              {showPoint && asserts.isExist(memberInfo) ? (
                <Popover content={renderMemberInfo()} placement="bottomRight">
                  <LinkTo to="/profile">
                    <span className="hover-red pointer">
                      {showPoint && memberPicUrl ? (
                        <img
                          style={{ width: 14, height: 14, marginRight: 4, borderRadius: '50%' }}
                          alt="加载中..."
                          src={`${process.env.ASSETS}/${memberPicUrl}`}
                        />
                      ) : (
                        <Icon type="user" />
                      )}
                      <Text>{principal.userName}</Text>
                    </span>
                  </LinkTo>
                </Popover>
              ) : (
                <LinkTo to="/profile">
                  <span className="hover-red pointer">
                    <Icon type="user" />
                    <Text>{principal.userName}</Text>
                  </span>
                </LinkTo>
              )}
              <Divider type="vertical" className="divider-xxs" />
              <PopUp title="确定要注销并退出系统吗？" onConfirm={logout} placement="bottomRight">
                <span className="hover-red pointer">
                  <Icon type="logout" />
                  <Text>退出</Text>
                </span>
              </PopUp>
            </>
          ) : (
            <>
              <LinkTo to="/login?record=1">
                <span className="hover-red pointer">
                  <Icon type="user" />
                  <Text>登录</Text>
                </span>
              </LinkTo>
              <Divider type="vertical" className="divider-xxs" />
              <LinkTo to="/register">
                <span className="hover-red pointer">
                  <Icon type="form" />
                  <Text>注册</Text>
                </span>
              </LinkTo>
            </>
          )}
          {visible ? (
            <CouponModal
              visible={visible}
              type={type}
              list={currentList}
              handleVisile={handleVisile}
              history={history}
            />
          ) : null}
          {signInVisible ? (
            <SignInModal signinFlag={signinFlag} onSignInSuccessFul={handleSignInSuccessFul} />
          ) : null}
        </aside>
      </main>
    </>
  );
});
